// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Control_Monad_Fork_Class from "../Control.Monad.Fork.Class/index.js";
import * as Control_Monad_Rec_Class from "../Control.Monad.Rec.Class/index.js";
import * as Data_Argonaut_Decode_Error from "../Data.Argonaut.Decode.Error/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Array_NonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data_Array_NonEmpty_Internal from "../Data.Array.NonEmpty.Internal/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Filterable from "../Data.Filterable/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_FunctorWithIndex from "../Data.FunctorWithIndex/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Lens_Setter from "../Data.Lens.Setter/index.js";
import * as Data_LoadDirection from "../Data.LoadDirection/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Profunctor_Strong from "../Data.Profunctor.Strong/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_TransmissionStats from "../Data.TransmissionStats/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Fusion_Class_MonadApp from "../Fusion.Class.MonadApp/index.js";
import * as Fusion_Data_Bytes from "../Fusion.Data.Bytes/index.js";
import * as Fusion_Data_Duration from "../Fusion.Data.Duration/index.js";
import * as Fusion_Data_FSError from "../Fusion.Data.FSError/index.js";
import * as Fusion_Data_FSErrorPart from "../Fusion.Data.FSErrorPart/index.js";
import * as Fusion_Data_FSValue from "../Fusion.Data.FSValue/index.js";
import * as Fusion_Data_Speed from "../Fusion.Data.Speed/index.js";
import * as Fusion_Data_Timestamp from "../Fusion.Data.Timestamp/index.js";
import * as Fusion_EnvVars_Common from "../Fusion.EnvVars.Common/index.js";
import * as Fusion_Foreign_Data_NQValue from "../Fusion.Foreign.Data.NQValue/index.js";
import * as Fusion_GenTransformers from "../Fusion.GenTransformers/index.js";
import * as Fusion_Generator from "../Fusion.Generator/index.js";
import * as Fusion_LoadIntermediate from "../Fusion.LoadIntermediate/index.js";
import * as Fusion_LoadOutput from "../Fusion.LoadOutput/index.js";
import * as Fusion_SpeedProcessing from "../Fusion.SpeedProcessing/index.js";
import * as MST_Data_BasicURL from "../MST.Data.BasicURL/index.js";
import * as Visonum_Cross_Extra_Lenses from "../Visonum.Cross.Extra.Lenses/index.js";
import * as WE_Class_AVar from "../WE.Class.AVar/index.js";
import * as WE_Class_MonadRef from "../WE.Class.MonadRef/index.js";
import * as WE_Class_Time from "../WE.Class.Time/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(Fusion_Data_Duration.monoidDuration);
var mempty1 = /* #__PURE__ */ Data_Monoid.mempty(Data_TransmissionStats.monoidTransmissionStats);
var throwError = /* #__PURE__ */ Control_Monad_Error_Class.throwError(Control_Monad_Error_Class.monadThrowEither);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var show = /* #__PURE__ */ Data_Show.show(Data_Argonaut_Decode_Error.showJsonDecodeError);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var toUnfoldable = /* #__PURE__ */ Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray);
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Array_NonEmpty_Internal.functorNonEmptyArray);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Data_Maybe.applicativeMaybe);
var minimum = /* #__PURE__ */ Data_Foldable.minimum(Fusion_Data_Timestamp.ordTimestamp)(Data_Foldable.foldableArray);
var maximum = /* #__PURE__ */ Data_Foldable.maximum(Fusion_Data_Timestamp.ordTimestamp)(Data_Foldable.foldableArray);
var foldMap = /* #__PURE__ */ Data_Foldable.foldMap(Data_Foldable.foldableArray);
var foldMap1 = /* #__PURE__ */ foldMap(Fusion_Data_Bytes.monoidBytes);
var foldMap2 = /* #__PURE__ */ Data_Foldable.foldMap(Data_Array_NonEmpty_Internal.foldableNonEmptyArray)(Fusion_Data_Bytes.monoidBytes);
var all = /* #__PURE__ */ Data_Foldable.all(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean);
var foldMap3 = /* #__PURE__ */ foldMap(Data_TransmissionStats.monoidTransmissionStats);
var eq = /* #__PURE__ */ Data_Eq.eq(MST_Data_BasicURL.eqBasicURL);
var sortWith = /* #__PURE__ */ Data_Array.sortWith(MST_Data_BasicURL.ordBasicURL);
var lmap = /* #__PURE__ */ Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither);
var fromJsonDecodeError2 = /* #__PURE__ */ Fusion_Data_FSErrorPart.fromJsonDecodeError2(Fusion_Foreign_Data_NQValue.nQValueMemberUploadFinalD);
var filterMap = /* #__PURE__ */ Data_Filterable.filterMap(Data_Filterable.filterableArray);
var mempty2 = /* #__PURE__ */ Data_Monoid.mempty(Fusion_Data_Bytes.monoidBytes);
var prop = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "serverSideLoadedBytes";
    }
})()()(Data_Profunctor_Strong.strongFn);
var alter = /* #__PURE__ */ Data_Map_Internal.alter(MST_Data_BasicURL.ordBasicURL);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Array_NonEmpty_Internal.semigroupNonEmptyArray);
var prop1 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "serverSideSpeeds";
    }
})()()(Data_Profunctor_Strong.strongFn);
var alter1 = /* #__PURE__ */ Data_Map_Internal.alter(Data_Ord.ordInt);
var $$null = /* #__PURE__ */ Data_Foldable["null"](Data_Foldable.foldableArray);
var fromJsonDecodeError21 = /* #__PURE__ */ Fusion_Data_FSErrorPart.fromJsonDecodeError2(Fusion_Foreign_Data_NQValue.nQValueMemberDownloadFina);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var eq1 = /* #__PURE__ */ Data_Eq.eq(Fusion_EnvVars_Common.eqNodeEnv);
var uploadMock = function (dictMonadApp) {
    var MonadAppNE4 = dictMonadApp.MonadAppNE4();
    var MonadKill3 = dictMonadApp.MonadKill3();
    var MonadError1 = (dictMonadApp.MonadBracket2()).MonadError1();
    var form2toForm1 = Fusion_Generator.form2toForm1(MonadAppNE4.ManageAVar3())(MonadAppNE4.MonadFork0())(MonadKill3)(MonadError1);
    var catchError = Control_Monad_Error_Class.catchError(MonadError1);
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var for_ = Data_Foldable.for_(Monad0.Applicative0())(Data_Foldable.foldableArray);
    var discard1 = discard(Monad0.Bind1());
    var delay = WE_Class_Time.delay(MonadAppNE4.MonadTime2());
    var throwError1 = Control_Monad_Error_Class.throwError(MonadKill3.MonadThrow1());
    return function (mockData) {
        var decode = function (fsValue) {
            if (fsValue instanceof Fusion_Data_FSValue.UploadIntermediate) {
                return pure(new Fusion_LoadOutput.TotalIntermediate({
                    speed: fsValue.value0.speed,
                    timestamp: Fusion_Data_Timestamp.timeIntervalSince1970(mempty)
                }));
            };
            if (fsValue instanceof Fusion_Data_FSValue.UploadFinal) {
                return pure(new Fusion_LoadOutput.Final({
                    jitter: fsValue.value0.jitter,
                    speed: fsValue.value0.speed,
                    statsActive: mempty1,
                    statsPassive: mempty1
                }));
            };
            return throwError(new Data_Argonaut_Decode_Error.TypeMismatch("Expected NQValue of kind UploadIntermediate or UploadFinal"));
        };
        return form2toForm1(function (emit) {
            return Data_Function.flip(catchError)(function (err) {
                return emit(new Data_Either.Left(err));
            })(for_(mockData)(function (uploadDE) {
                return discard1(delay(Fusion_Data_Duration.fromMs(100.0)))(function () {
                    var v = decode(uploadDE);
                    if (v instanceof Data_Either.Right) {
                        return emit(new Data_Either.Right(v.value0));
                    };
                    if (v instanceof Data_Either.Left) {
                        return throwError1(Fusion_Data_FSError.mk(Fusion_Data_FSError.Cl62.value)(show(v.value0)));
                    };
                    throw new Error("Failed pattern match at Fusion.LoadFinal (line 488, column 11 - line 490, column 72): " + [ v.constructor.name ]);
                });
            }));
        });
    };
};
var stripStatsUrls = function (dictFunctor) {
    var map3 = Data_Functor.map(dictFunctor);
    return function (enableTcpStats) {
        return function (urlsWithStats) {
            if (!enableTcpStats) {
                return map3(function (v) {
                    return {
                        load: v.load,
                        progress: v.progress,
                        stats: Data_Maybe.Nothing.value
                    };
                })(urlsWithStats);
            };
            if (enableTcpStats) {
                return urlsWithStats;
            };
            throw new Error("Failed pattern match at Fusion.LoadFinal (line 562, column 3 - line 567, column 20): " + [ enableTcpStats.constructor.name ]);
        };
    };
};
var speedMock = [ {
    total: /* #__PURE__ */ Fusion_Data_Speed.fromBps(5.0e7),
    stream1: /* #__PURE__ */ Fusion_Data_Speed.fromBps(3.0e7),
    stream2: /* #__PURE__ */ Fusion_Data_Speed.fromBps(2.0e7),
    stream3: /* #__PURE__ */ Fusion_Data_Speed.fromBps(4.3e7)
}, {
    total: /* #__PURE__ */ Fusion_Data_Speed.fromBps(5.3e7),
    stream1: /* #__PURE__ */ Fusion_Data_Speed.fromBps(3.1e7),
    stream2: /* #__PURE__ */ Fusion_Data_Speed.fromBps(2.0e7),
    stream3: /* #__PURE__ */ Fusion_Data_Speed.fromBps(4.5e7)
}, {
    total: /* #__PURE__ */ Fusion_Data_Speed.fromBps(5.7e7),
    stream1: /* #__PURE__ */ Fusion_Data_Speed.fromBps(3.3e7),
    stream2: /* #__PURE__ */ Fusion_Data_Speed.fromBps(2.3e7),
    stream3: /* #__PURE__ */ Fusion_Data_Speed.fromBps(4.2e7)
}, {
    total: /* #__PURE__ */ Fusion_Data_Speed.fromBps(6.0e7),
    stream1: /* #__PURE__ */ Fusion_Data_Speed.fromBps(3.4e7),
    stream2: /* #__PURE__ */ Fusion_Data_Speed.fromBps(2.1e7),
    stream3: /* #__PURE__ */ Fusion_Data_Speed.fromBps(4.0e7)
}, {
    total: /* #__PURE__ */ Fusion_Data_Speed.fromBps(5.8e7),
    stream1: /* #__PURE__ */ Fusion_Data_Speed.fromBps(3.5e7),
    stream2: /* #__PURE__ */ Fusion_Data_Speed.fromBps(2.0e7),
    stream3: /* #__PURE__ */ Fusion_Data_Speed.fromBps(4.2e7)
}, {
    total: /* #__PURE__ */ Fusion_Data_Speed.fromBps(5.5e7),
    stream1: /* #__PURE__ */ Fusion_Data_Speed.fromBps(3.6e7),
    stream2: /* #__PURE__ */ Fusion_Data_Speed.fromBps(2.0e7),
    stream3: /* #__PURE__ */ Fusion_Data_Speed.fromBps(3.8e7)
}, {
    total: /* #__PURE__ */ Fusion_Data_Speed.fromBps(6.05e7),
    stream1: /* #__PURE__ */ Fusion_Data_Speed.fromBps(3.7e7),
    stream2: /* #__PURE__ */ Fusion_Data_Speed.fromBps(1.9e7),
    stream3: /* #__PURE__ */ Fusion_Data_Speed.fromBps(3.7e7)
}, {
    total: /* #__PURE__ */ Fusion_Data_Speed.fromBps(5.85e7),
    stream1: /* #__PURE__ */ Fusion_Data_Speed.fromBps(3.6e7),
    stream2: /* #__PURE__ */ Fusion_Data_Speed.fromBps(2.1e7),
    stream3: /* #__PURE__ */ Fusion_Data_Speed.fromBps(3.6e7)
}, {
    total: /* #__PURE__ */ Fusion_Data_Speed.fromBps(5.55e7),
    stream1: /* #__PURE__ */ Fusion_Data_Speed.fromBps(3.4e7),
    stream2: /* #__PURE__ */ Fusion_Data_Speed.fromBps(2.5e7),
    stream3: /* #__PURE__ */ Fusion_Data_Speed.fromBps(3.5e7)
}, {
    total: /* #__PURE__ */ Fusion_Data_Speed.fromBps(5.2e7),
    stream1: /* #__PURE__ */ Fusion_Data_Speed.fromBps(3.2e7),
    stream2: /* #__PURE__ */ Fusion_Data_Speed.fromBps(2.4e7),
    stream3: /* #__PURE__ */ Fusion_Data_Speed.fromBps(3.8e7)
}, {
    total: /* #__PURE__ */ Fusion_Data_Speed.fromBps(5.7e7),
    stream1: /* #__PURE__ */ Fusion_Data_Speed.fromBps(3.0e7),
    stream2: /* #__PURE__ */ Fusion_Data_Speed.fromBps(2.3e7),
    stream3: /* #__PURE__ */ Fusion_Data_Speed.fromBps(4.0e7)
}, {
    total: /* #__PURE__ */ Fusion_Data_Speed.fromBps(5.4e7),
    stream1: /* #__PURE__ */ Fusion_Data_Speed.fromBps(2.9e7),
    stream2: /* #__PURE__ */ Fusion_Data_Speed.fromBps(2.5e7),
    stream3: /* #__PURE__ */ Fusion_Data_Speed.fromBps(4.2e7)
}, {
    total: /* #__PURE__ */ Fusion_Data_Speed.fromBps(5.0e7),
    stream1: /* #__PURE__ */ Fusion_Data_Speed.fromBps(2.8e7),
    stream2: /* #__PURE__ */ Fusion_Data_Speed.fromBps(2.4e7),
    stream3: /* #__PURE__ */ Fusion_Data_Speed.fromBps(4.3e7)
}, {
    total: /* #__PURE__ */ Fusion_Data_Speed.fromBps(4.6e7),
    stream1: /* #__PURE__ */ Fusion_Data_Speed.fromBps(2.6e7),
    stream2: /* #__PURE__ */ Fusion_Data_Speed.fromBps(2.3e7),
    stream3: /* #__PURE__ */ Fusion_Data_Speed.fromBps(4.2e7)
}, {
    total: /* #__PURE__ */ Fusion_Data_Speed.fromBps(4.2e7),
    stream1: /* #__PURE__ */ Fusion_Data_Speed.fromBps(2.5e7),
    stream2: /* #__PURE__ */ Fusion_Data_Speed.fromBps(2.2e7),
    stream3: /* #__PURE__ */ Fusion_Data_Speed.fromBps(4.1e7)
}, {
    total: /* #__PURE__ */ Fusion_Data_Speed.fromBps(4.4e7),
    stream1: /* #__PURE__ */ Fusion_Data_Speed.fromBps(2.7e7),
    stream2: /* #__PURE__ */ Fusion_Data_Speed.fromBps(2.1e7),
    stream3: /* #__PURE__ */ Fusion_Data_Speed.fromBps(3.9e7)
}, {
    total: /* #__PURE__ */ Fusion_Data_Speed.fromBps(4.05e7),
    stream1: /* #__PURE__ */ Fusion_Data_Speed.fromBps(2.9e7),
    stream2: /* #__PURE__ */ Fusion_Data_Speed.fromBps(2.0e7),
    stream3: /* #__PURE__ */ Fusion_Data_Speed.fromBps(3.8e7)
}, {
    total: /* #__PURE__ */ Fusion_Data_Speed.fromBps(3.85e7),
    stream1: /* #__PURE__ */ Fusion_Data_Speed.fromBps(3.0e7),
    stream2: /* #__PURE__ */ Fusion_Data_Speed.fromBps(1.9e7),
    stream3: /* #__PURE__ */ Fusion_Data_Speed.fromBps(3.5e7)
}, {
    total: /* #__PURE__ */ Fusion_Data_Speed.fromBps(3.9e7),
    stream1: /* #__PURE__ */ Fusion_Data_Speed.fromBps(2.9e7),
    stream2: /* #__PURE__ */ Fusion_Data_Speed.fromBps(1.8e7),
    stream3: /* #__PURE__ */ Fusion_Data_Speed.fromBps(3.6e7)
}, {
    total: /* #__PURE__ */ Fusion_Data_Speed.fromBps(4.1e7),
    stream1: /* #__PURE__ */ Fusion_Data_Speed.fromBps(2.8e7),
    stream2: /* #__PURE__ */ Fusion_Data_Speed.fromBps(1.7e7),
    stream3: /* #__PURE__ */ Fusion_Data_Speed.fromBps(3.8e7)
}, {
    total: /* #__PURE__ */ Fusion_Data_Speed.fromBps(4.35e7),
    stream1: /* #__PURE__ */ Fusion_Data_Speed.fromBps(2.7e7),
    stream2: /* #__PURE__ */ Fusion_Data_Speed.fromBps(2.0e7),
    stream3: /* #__PURE__ */ Fusion_Data_Speed.fromBps(3.6e7)
}, {
    total: /* #__PURE__ */ Fusion_Data_Speed.fromBps(4.6e7),
    stream1: /* #__PURE__ */ Fusion_Data_Speed.fromBps(2.6e7),
    stream2: /* #__PURE__ */ Fusion_Data_Speed.fromBps(1.9e7),
    stream3: /* #__PURE__ */ Fusion_Data_Speed.fromBps(3.5e7)
}, {
    total: /* #__PURE__ */ Fusion_Data_Speed.fromBps(4.85e7),
    stream1: /* #__PURE__ */ Fusion_Data_Speed.fromBps(2.7e7),
    stream2: /* #__PURE__ */ Fusion_Data_Speed.fromBps(1.8e7),
    stream3: /* #__PURE__ */ Fusion_Data_Speed.fromBps(3.6e7)
}, {
    total: /* #__PURE__ */ Fusion_Data_Speed.fromBps(5.1e7),
    stream1: /* #__PURE__ */ Fusion_Data_Speed.fromBps(2.8e7),
    stream2: /* #__PURE__ */ Fusion_Data_Speed.fromBps(1.7e7),
    stream3: /* #__PURE__ */ Fusion_Data_Speed.fromBps(3.7e7)
}, {
    total: /* #__PURE__ */ Fusion_Data_Speed.fromBps(4.8e7),
    stream1: /* #__PURE__ */ Fusion_Data_Speed.fromBps(2.9e7),
    stream2: /* #__PURE__ */ Fusion_Data_Speed.fromBps(1.8e7),
    stream3: /* #__PURE__ */ Fusion_Data_Speed.fromBps(3.9e7)
} ];
var mapToArray = function (dictOrd) {
    var compare = Data_Ord.compare(dictOrd);
    return function (mp) {
        return map(Data_Tuple.snd)(Data_Array.sortBy(function (v) {
            return function (v1) {
                return compare(v.value0)(v1.value0);
            };
        })(toUnfoldable(mp)));
    };
};
var mapToArray1 = /* #__PURE__ */ mapToArray(MST_Data_BasicURL.ordBasicURL);
var mkServerSide = function (v) {
    var loadedBytesStreams = mapToArray1(v.loadedBytes);
    var maybeTimeBinIntermediateValues = bind(Data_Array_NonEmpty.fromArray(loadedBytesStreams))(function (loadedBytesStreamsNEA) {
        var dataPoints = Fusion_SpeedProcessing.binIntermediateSpeeds(v.coalesceInterval)(map1(function (v1) {
            return {
                loadedBytes: v1.loadedBytes,
                startTime: v1.startTime
            };
        })(loadedBytesStreamsNEA));
        var speedValues = map(function (v1) {
            return v1.speed;
        })(dataPoints);
        return pure1(speedValues);
    });
    var maybeTransferDuration = (function () {
        var startTimes = map(function (v1) {
            return v1.startTime;
        })(loadedBytesStreams);
        var endTimes = map(function (item) {
            return Fusion_Data_Timestamp.addDuration(item.startTime)((function (v1) {
                return v1.durationSinceStart;
            })(Data_Array_NonEmpty.last(item.loadedBytes)));
        })(loadedBytesStreams);
        return bind(minimum(startTimes))(function (startTime) {
            return bind(maximum(endTimes))(function (endTime) {
                return pure1(Fusion_Data_Timestamp.diff(endTime)(startTime));
            });
        });
    })();
    var transferredBytes = foldMap1(function (v1) {
        return foldMap2(function (v2) {
            return v2.bytes;
        })(v1.loadedBytes);
    })(loadedBytesStreams);
    var maybeTimeBinFinal = bind(maybeTimeBinIntermediateValues)(function (intermediateValuesRaw) {
        var intermediateValues = Data_Maybe.fromMaybe([  ])(Data_Array.init(intermediateValuesRaw));
        return bind(maybeTransferDuration)(function (dur) {
            var calcFinalInputs = {
                transferDuration: dur,
                transferredBytes: transferredBytes,
                intermediateValues: intermediateValues
            };
            return pure1(Fusion_SpeedProcessing.calcFinal(calcFinalInputs));
        });
    });
    return {
        transferDuration: maybeTransferDuration,
        transferredBytes: transferredBytes,
        intermediateValues: Data_Maybe.fromMaybe([  ])(maybeTimeBinIntermediateValues),
        "final": maybeTimeBinFinal,
        streams: loadedBytesStreams
    };
};
var makeStreamIntermediates = function (timestamp) {
    return function (stream1) {
        return function (stream2) {
            return function (stream3) {
                return [ new Fusion_LoadOutput.StreamIntermediate({
                    timestamp: timestamp,
                    speed: stream1,
                    streamIndex: 1
                }), new Fusion_LoadOutput.StreamIntermediate({
                    timestamp: timestamp,
                    speed: stream2,
                    streamIndex: 2
                }), new Fusion_LoadOutput.StreamIntermediate({
                    timestamp: timestamp,
                    speed: stream3,
                    streamIndex: 3
                }) ];
            };
        };
    };
};
var isUsableStats = function (v) {
    if (v.sent instanceof Data_Maybe.Just && v.received instanceof Data_Maybe.Just) {
        return all(Data_Maybe.isJust)([ v.sent.value0.totalPackets, v.sent.value0.lostBytes, v.sent.value0.totalBytes, v.received.value0.outOfOrder, v.received.value0.duplicate, v.received.value0.total ]);
    };
    return false;
};
var infoGroupToModel = function (group) {
    var groupArray = Data_Array_NonEmpty.toArray(group);
    var first = Data_Array_NonEmpty.head(group);
    return {
        url: MST_Data_BasicURL.print(first.url),
        kernelName: first.kernelName,
        kernelVersion: first.kernelVersion,
        intermediateStats: map(function (s) {
            return s.stats;
        })(groupArray),
        finalStats: foldMap3(function (s) {
            return s.stats;
        })(groupArray)
    };
};
var infosToModels = function (statsInfos) {
    return map(infoGroupToModel)(Data_Array.groupBy(function (a) {
        return function (b) {
            return eq(a.url)(b.url);
        };
    })(sortWith(function (v) {
        return v.url;
    })(statsInfos)));
};
var finalMock = /* #__PURE__ */ (function () {
    return new Fusion_LoadOutput.Final({
        jitter: Fusion_Data_Speed.fromBps(4000000.0),
        speed: Fusion_Data_Speed.fromBps(1.0e8),
        statsActive: mempty1,
        statsPassive: mempty1
    });
})();
var downloadMock = function (dictMonadApp) {
    var MonadAppNE4 = dictMonadApp.MonadAppNE4();
    var MonadError1 = (dictMonadApp.MonadBracket2()).MonadError1();
    var form2toForm1 = Fusion_Generator.form2toForm1(MonadAppNE4.ManageAVar3())(MonadAppNE4.MonadFork0())(dictMonadApp.MonadKill3())(MonadError1);
    var catchError = Control_Monad_Error_Class.catchError(MonadError1);
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var Bind1 = Monad0.Bind1();
    var discard1 = discard(Bind1);
    var for_ = Data_Foldable.for_(Monad0.Applicative0())(Data_Foldable.foldableArray);
    var MonadTime2 = MonadAppNE4.MonadTime2();
    var delay = WE_Class_Time.delay(MonadTime2);
    var bind1 = Control_Bind.bind(Bind1);
    var now = WE_Class_Time.now(MonadTime2);
    return function (mockData) {
        return form2toForm1(function (emit) {
            return Data_Function.flip(catchError)(function (err) {
                return emit(new Data_Either.Left(err));
            })(discard1(for_(Data_Array.concat(Data_Array.replicate(1)(speedMock)))(function (v) {
                return discard1(delay(Fusion_Data_Duration.fromMs(100.0)))(function () {
                    return bind1(now)(function (timeNow) {
                        var totalIntermediateEntry = new Fusion_LoadOutput.TotalIntermediate({
                            timestamp: timeNow,
                            speed: v.total
                        });
                        return discard1(emit(new Data_Either.Right(totalIntermediateEntry)))(function () {
                            return for_(makeStreamIntermediates(timeNow)(v.stream1)(v.stream2)(v.stream3))(function (stream) {
                                return emit(new Data_Either.Right(stream));
                            });
                        });
                    });
                });
            }))(function () {
                return emit(new Data_Either.Right(finalMock));
            }));
        });
    };
};
var calcUpload = function (dictMonadApp) {
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var bind1 = Control_Bind.bind(Monad0.Bind1());
    var liftEither = Control_Monad_Error_Class.liftEither((dictMonadApp.MonadKill3()).MonadThrow1());
    var pure2 = Control_Applicative.pure(Monad0.Applicative0());
    return function (sdk) {
        return function (request) {
            return bind1(sdk.calcUpload(request))(function (calcResult) {
                return bind1(liftEither(lmap(fromJsonDecodeError2(Fusion_Data_FSError.Cl66.value)(calcResult))(Fusion_Foreign_Data_NQValue.decodeFSUploadFinal(calcResult))))(function (v) {
                    return pure2({
                        speed: v.speed,
                        jitter: v.jitter
                    });
                });
            });
        };
    };
};
var calcStatsFinal = function (models) {
    return foldMap3(function (v) {
        return v.finalStats;
    })(filterMap(function (v) {
        var $228 = isUsableStats(v.finalStats);
        if ($228) {
            return new Data_Maybe.Just(v);
        };
        return Data_Maybe.Nothing.value;
    })(models));
};
var loadFinal = function (dictMonadApp) {
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var Bind1 = Monad0.Bind1();
    var bind1 = Control_Bind.bind(Bind1);
    var MonadAppNE4 = dictMonadApp.MonadAppNE4();
    var ManageAVar3 = MonadAppNE4.ManageAVar3();
    var empty = WE_Class_AVar.empty(ManageAVar3);
    var put = WE_Class_AVar.put(ManageAVar3);
    var MonadRef4 = MonadAppNE4.MonadRef4();
    var $$new = WE_Class_MonadRef["new"](MonadRef4);
    var MonadBracket2 = dictMonadApp.MonadBracket2();
    var bracket = Control_Monad_Fork_Class.bracket(MonadBracket2);
    var groupedAverage = Fusion_GenTransformers.groupedAverage(dictMonadApp);
    var loadIntermediate = Fusion_LoadIntermediate.loadIntermediate(dictMonadApp);
    var Applicative0 = Monad0.Applicative0();
    var pure2 = Control_Applicative.pure(Applicative0);
    var discard1 = discard(Bind1);
    var forever = Control_Monad_Rec_Class.forever(MonadAppNE4.MonadRec1());
    var MonadKill3 = dictMonadApp.MonadKill3();
    var throwError1 = Control_Monad_Error_Class.throwError(MonadKill3.MonadThrow1());
    var modify_ = WE_Class_MonadRef.modify_(MonadRef4);
    var fork = Control_Monad_Fork_Class.fork(MonadAppNE4.MonadFork0());
    var catchError = Control_Monad_Error_Class.catchError(MonadBracket2.MonadError1());
    var MonadTime2 = MonadAppNE4.MonadTime2();
    var now = WE_Class_Time.now(MonadTime2);
    var parOneOf = Fusion_Class_MonadApp.parOneOf(MonadAppNE4.MonadRaceInParallel7())(Data_Traversable.traversableArray)(Data_FunctorWithIndex.functorWithIndexArray)(Data_Eq.eqInt);
    var voidLeft = Data_Functor.voidLeft((Bind1.Apply0()).Functor0());
    var delay = WE_Class_Time.delay(MonadTime2);
    var when = Control_Applicative.when(Applicative0);
    var read = WE_Class_MonadRef.read(MonadRef4);
    var MonadFetch6 = MonadAppNE4.MonadFetch6();
    var getPerformanceStats = Fusion_Class_MonadApp.getPerformanceStats(MonadFetch6);
    var getDeviceMemory = Fusion_Class_MonadApp.getDeviceMemory(MonadFetch6);
    var getPerformanceMemory = Fusion_Class_MonadApp.getPerformanceMemory(MonadFetch6);
    var take = WE_Class_AVar.take(ManageAVar3);
    var kill_ = Fusion_Generator.kill_(MonadKill3);
    return function (v) {
        return function (loadDirection) {
            return function (speedtestId) {
                return function (v1) {
                    return bind1(empty)(function (av) {
                        var emit = function (v2) {
                            return put(v2)(av);
                        };
                        var coalesceInterval = Fusion_Data_Duration.fromMs(500.0);
                        return bind1($$new({
                            speeds: [  ],
                            serverSideSpeeds: Data_Map_Internal.empty,
                            serverSideLoadedBytes: Data_Map_Internal.empty,
                            bytes: mempty2,
                            tcpStatsActive: [  ],
                            tcpStatsPassive: [  ]
                        }))(function (ref) {
                            var executor = bracket(groupedAverage(v1.countStreams)(loadIntermediate(v.engineConnection)(loadDirection)({
                                urls: v1.urls,
                                countStreams: v1.countStreams,
                                coalesceInterval: coalesceInterval
                            })))(function (bc) {
                                return function (gen) {
                                    if (bc instanceof Control_Monad_Fork_Class.Completed) {
                                        return pure2(Data_Unit.unit);
                                    };
                                    if (bc instanceof Control_Monad_Fork_Class.Killed) {
                                        return Fusion_Generator.cancel(gen);
                                    };
                                    if (bc instanceof Control_Monad_Fork_Class.Failed) {
                                        return discard1(emit(new Data_Either.Left(bc.value0)))(function () {
                                            return Fusion_Generator.cancel(gen);
                                        });
                                    };
                                    throw new Error("Failed pattern match at Fusion.LoadFinal (line 144, column 13 - line 150, column 31): " + [ bc.constructor.name ]);
                                };
                            })(function (gen) {
                                return forever(bind1(Fusion_Generator.next(gen))(function (v2) {
                                    if (v2 instanceof Data_Either.Left) {
                                        return throwError1(v2.value0);
                                    };
                                    if (v2 instanceof Data_Either.Right) {
                                        return discard1(emit(new Data_Either.Right(v2.value0)))(function () {
                                            if (v2.value0 instanceof Fusion_LoadOutput.Current) {
                                                return modify_(ref)(function (state) {
                                                    return {
                                                        serverSideLoadedBytes: state.serverSideLoadedBytes,
                                                        serverSideSpeeds: state.serverSideSpeeds,
                                                        speeds: state.speeds,
                                                        tcpStatsActive: state.tcpStatsActive,
                                                        tcpStatsPassive: state.tcpStatsPassive,
                                                        bytes: v2.value0.value0.bytes
                                                    };
                                                });
                                            };
                                            if (v2.value0 instanceof Fusion_LoadOutput.TotalIntermediate) {
                                                return modify_(ref)(function (state) {
                                                    return {
                                                        bytes: state.bytes,
                                                        serverSideLoadedBytes: state.serverSideLoadedBytes,
                                                        serverSideSpeeds: state.serverSideSpeeds,
                                                        tcpStatsActive: state.tcpStatsActive,
                                                        tcpStatsPassive: state.tcpStatsPassive,
                                                        speeds: Data_Array.snoc(state.speeds)(v2.value0.value0.speed)
                                                    };
                                                });
                                            };
                                            if (v2.value0 instanceof Fusion_LoadOutput.StreamIntermediate) {
                                                return pure2(Data_Unit.unit);
                                            };
                                            if (v2.value0 instanceof Fusion_LoadOutput.IntermediateStatsPassive) {
                                                return modify_(ref)(function (state) {
                                                    return {
                                                        bytes: state.bytes,
                                                        serverSideLoadedBytes: state.serverSideLoadedBytes,
                                                        serverSideSpeeds: state.serverSideSpeeds,
                                                        speeds: state.speeds,
                                                        tcpStatsActive: state.tcpStatsActive,
                                                        tcpStatsPassive: Data_Array.snoc(state.tcpStatsPassive)(v2.value0.value0)
                                                    };
                                                });
                                            };
                                            if (v2.value0 instanceof Fusion_LoadOutput.IntermediateStatsActive) {
                                                return modify_(ref)(function (state) {
                                                    return {
                                                        bytes: state.bytes,
                                                        serverSideLoadedBytes: state.serverSideLoadedBytes,
                                                        serverSideSpeeds: state.serverSideSpeeds,
                                                        speeds: state.speeds,
                                                        tcpStatsPassive: state.tcpStatsPassive,
                                                        tcpStatsActive: Data_Array.snoc(state.tcpStatsActive)(v2.value0.value0)
                                                    };
                                                });
                                            };
                                            if (v2.value0 instanceof Fusion_LoadOutput.ServerSideLoadedBytes) {
                                                return modify_(ref)(Data_Lens_Setter.over(prop)(alter(function (v3) {
                                                    if (v3 instanceof Data_Maybe.Nothing) {
                                                        return new Data_Maybe.Just({
                                                            url: v2.value0.value0.url,
                                                            startTime: v2.value0.value0.startTime,
                                                            loadedBytes: v2.value0.value0.loadedBytes,
                                                            streamIndex: v2.value0.value0.streamIndex
                                                        });
                                                    };
                                                    if (v3 instanceof Data_Maybe.Just) {
                                                        return new Data_Maybe.Just({
                                                            startTime: v3.value0.startTime,
                                                            streamIndex: v3.value0.streamIndex,
                                                            url: v3.value0.url,
                                                            loadedBytes: append(v3.value0.loadedBytes)(v2.value0.value0.loadedBytes)
                                                        });
                                                    };
                                                    throw new Error("Failed pattern match at Fusion.LoadFinal (line 183, column 27 - line 190, column 104): " + [ v3.constructor.name ]);
                                                })(v2.value0.value0.url)));
                                            };
                                            if (v2.value0 instanceof Fusion_LoadOutput.ServerSideStreamIntermediate) {
                                                return modify_(ref)(Data_Lens_Setter.over(prop1)(alter1(function (v3) {
                                                    if (v3 instanceof Data_Maybe.Nothing) {
                                                        return new Data_Maybe.Just([ {
                                                            speed: v2.value0.value0.speed,
                                                            timestamp: v2.value0.value0.timestamp
                                                        } ]);
                                                    };
                                                    if (v3 instanceof Data_Maybe.Just) {
                                                        return new Data_Maybe.Just(Data_Array.snoc(v3.value0)({
                                                            speed: v2.value0.value0.speed,
                                                            timestamp: v2.value0.value0.timestamp
                                                        }));
                                                    };
                                                    throw new Error("Failed pattern match at Fusion.LoadFinal (line 198, column 27 - line 200, column 111): " + [ v3.constructor.name ]);
                                                })(v2.value0.value0.streamIndex)));
                                            };
                                            if (v2.value0 instanceof Fusion_LoadOutput.ServerSideTotalIntermediate) {
                                                return pure2(Data_Unit.unit);
                                            };
                                            if (v2.value0 instanceof Fusion_LoadOutput.Warning) {
                                                return pure2(Data_Unit.unit);
                                            };
                                            if (v2.value0 instanceof Fusion_LoadOutput.Final) {
                                                return pure2(Data_Unit.unit);
                                            };
                                            throw new Error("Failed pattern match at Fusion.LoadFinal (line 159, column 15 - line 212, column 37): " + [ v2.value0.constructor.name ]);
                                        });
                                    };
                                    throw new Error("Failed pattern match at Fusion.LoadFinal (line 154, column 11 - line 212, column 37): " + [ v2.constructor.name ]);
                                }));
                            });
                            return bind1(fork(Data_Function.flip(catchError)(function (err) {
                                return emit(new Data_Either.Left(err));
                            })(bind1(now)(function (timeStart) {
                                return bind1(parOneOf([ voidLeft(delay(v1.duration))(true), voidLeft(executor)(false) ]))(function (v2) {
                                    return when(v2)(bind1(now)(function (timeEnd) {
                                        return bind1(read(ref))(function (state) {
                                            return discard1(when($$null(state.speeds))((function () {
                                                if (loadDirection instanceof Data_LoadDirection.DownloadP) {
                                                    return throwError1(Fusion_Data_FSError.mk(Fusion_Data_FSError.DnCn52.value)("No intermediates on download"));
                                                };
                                                if (loadDirection instanceof Data_LoadDirection.UploadP) {
                                                    return throwError1(Fusion_Data_FSError.mk(Fusion_Data_FSError.UpCn52.value)("No intermediates on upload"));
                                                };
                                                throw new Error("Failed pattern match at Fusion.LoadFinal (line 233, column 13 - line 239, column 84): " + [ loadDirection.constructor.name ]);
                                            })()))(function () {
                                                var activeModel = infosToModels(state.tcpStatsActive);
                                                var finalStatsActive = calcStatsFinal(activeModel);
                                                var passiveModel = infosToModels(state.tcpStatsPassive);
                                                var finalStatsPassive = calcStatsFinal(passiveModel);
                                                return bind1(getPerformanceStats)(function (performanceStats) {
                                                    return bind1(getDeviceMemory)(function (deviceMemory) {
                                                        return bind1(getPerformanceMemory)(function (performanceMemory) {
                                                            var calcRequest = {
                                                                intermediateValues: state.speeds,
                                                                speedtestId: speedtestId,
                                                                transferDuration: Fusion_Data_Timestamp.diff(timeEnd)(timeStart),
                                                                transferredBytes: state.bytes,
                                                                tcpStats: {
                                                                    active: activeModel,
                                                                    passive: passiveModel,
                                                                    activeFinal: finalStatsActive,
                                                                    passiveFinal: finalStatsPassive
                                                                },
                                                                serverSide: mkServerSide({
                                                                    speeds: state.serverSideSpeeds,
                                                                    loadedBytes: state.serverSideLoadedBytes,
                                                                    coalesceInterval: coalesceInterval
                                                                }),
                                                                performanceStats: performanceStats,
                                                                deviceMemory: deviceMemory,
                                                                performanceMemory: performanceMemory
                                                            };
                                                            return bind1(v.calcLoad(calcRequest))(function (calcResult) {
                                                                return emit(new Data_Either.Right(new Fusion_LoadOutput.Final({
                                                                    speed: calcResult.speed,
                                                                    jitter: calcResult.jitter,
                                                                    statsActive: finalStatsActive,
                                                                    statsPassive: finalStatsPassive
                                                                })));
                                                            });
                                                        });
                                                    });
                                                });
                                            });
                                        });
                                    }));
                                });
                            }))))(function (fiber) {
                                return pure2({
                                    next: take(av),
                                    cancel: kill_(fiber)
                                });
                            });
                        });
                    });
                };
            };
        };
    };
};
var calcDownload = function (dictMonadApp) {
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var bind1 = Control_Bind.bind(Monad0.Bind1());
    var liftEither = Control_Monad_Error_Class.liftEither((dictMonadApp.MonadKill3()).MonadThrow1());
    var pure2 = Control_Applicative.pure(Monad0.Applicative0());
    return function (sdk) {
        return function (request) {
            return bind1(sdk.calcDownload(request))(function (calcResult) {
                return bind1(liftEither(lmap(fromJsonDecodeError21(Fusion_Data_FSError.Cl65.value)(calcResult))(Fusion_Foreign_Data_NQValue.decodeFSDownloadFinal(calcResult))))(function (v) {
                    return pure2({
                        speed: v.speed,
                        jitter: v.jitter
                    });
                });
            });
        };
    };
};
var addSpeedtestIdParam = function (dictFunctor) {
    var map3 = Data_Functor.map(dictFunctor);
    return function (speedtestId) {
        return function (urls) {
            var add = MST_Data_BasicURL.addQueryParameterIfNotExists("speedtestId")(new Data_Maybe.Just(speedtestId));
            var convert = function (v) {
                return {
                    load: add(v.load),
                    stats: map2(add)(v.stats),
                    progress: map2(add)(v.progress)
                };
            };
            return map3(convert)(urls);
        };
    };
};
var addDisableCorsParam = function (dictFunctor) {
    var map3 = Data_Functor.map(dictFunctor);
    return function (urls) {
        var add = MST_Data_BasicURL.addQueryParameterIfNotExists("disable_cors")(new Data_Maybe.Just("rof-kict-flam"));
        var convert = function (v) {
            return {
                load: add(v.load),
                stats: map2(add)(v.stats),
                progress: map2(add)(v.progress)
            };
        };
        var $276 = eq1(Fusion_EnvVars_Common.envVarsCommon.NODE_ENV)(Fusion_EnvVars_Common.Development.value);
        if ($276) {
            return map3(convert)(urls);
        };
        return urls;
    };
};
export {
    addDisableCorsParam,
    addSpeedtestIdParam,
    calcDownload,
    calcUpload,
    downloadMock,
    loadFinal,
    stripStatsUrls,
    uploadMock
};
//# sourceMappingURL=index.js.map
